import { Controller } from "@hotwired/stimulus"

// Color picker dedicado al editor visual de paginas web.
//
// Replica WebsiteColorBtn.tsx del frontend: circulo de color que abre
// un dropdown con input color nativo + hex editable + preset colors.
//
// A diferencia de `manage--color-picker` (acoplado al controller
// `manage--appearance`), este controller es generico: escribe el valor
// elegido en un hidden input `name="..."` que va dentro del form del
// tab Configuracion, sin dependencias cruzadas.
//
// Estructura esperada en el HTML:
//
//   <div data-controller="manage--editor-color-picker">
//     <input type="hidden" name="page_style_form[css][color]"
//            value="#000"
//            data-manage--editor-color-picker-target="hidden">
//     <button data-action="click->manage--editor-color-picker#toggle"
//             data-manage--editor-color-picker-target="trigger">
//     <div class="hidden" data-manage--editor-color-picker-target="panel">
//       <input type="color" ...
//              data-manage--editor-color-picker-target="colorInput"
//              data-action="input->manage--editor-color-picker#onColorChange">
//       <input type="text" ...
//              data-manage--editor-color-picker-target="hexInput"
//              data-action="change->manage--editor-color-picker#onHexChange">
//       <button ... data-color="#F47373"
//               data-action="click->manage--editor-color-picker#pickPreset">
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["trigger", "panel", "colorInput", "hexInput", "hidden"]

  #onClick = null

  connect() {
    this.#onClick = this.#handleOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.#onClick)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    const isOpen = !this.panelTarget.classList.contains("hidden")
    isOpen ? this.#close() : this.#open()
  }

  onColorChange() {
    const color = this.colorInputTarget.value
    this.#setColor(color)
  }

  onHexChange() {
    let hex = this.hexInputTarget.value.trim()
    if (!hex.startsWith("#")) hex = "#" + hex

    if (/^#[0-9A-Fa-f]{6}$/.test(hex)) {
      this.#setColor(hex)
    } else {
      // Revertir al valor valido previo
      this.hexInputTarget.value = (this.hiddenTarget.value || "#000000").toUpperCase()
    }
  }

  pickPreset(event) {
    event.preventDefault()
    const color = event.currentTarget.dataset.color
    this.#setColor(color)
  }

  // Private

  #setColor(hex) {
    this.hiddenTarget.value = hex
    this.colorInputTarget.value = hex
    this.hexInputTarget.value = hex.toUpperCase()
    this.triggerTarget.style.backgroundColor = hex
    this.hiddenTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  #open() {
    this.panelTarget.classList.remove("hidden")
    document.addEventListener("click", this.#onClick)
  }

  #close() {
    this.panelTarget.classList.add("hidden")
    document.removeEventListener("click", this.#onClick)
  }

  #handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.#close()
    }
  }
}
